angular.module('TetherApp').factory('messengerConversationModalService', [
    '$http',
    '$mdDialog',
    '$interval',
    'messengerConversationService',
    'messengerMessageService',
    function (
        $http,
        $mdDialog,
        $interval,
        messengerConversationService,
        messengerMessageService
    ) {

        let self = this;

        self.participantMessages = [];

        let randomString = function () {
            let result = '';
            let length = 16;
            let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getParticipant = function (participantId) {
            return $http.get(
                '/api/v1/participants/' + participantId + '/' + randomString(),
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getConversationModal = function(ev, page, participantId, conversationId) {
            self.conversationModalPage = page;
            self.conversationModalParticipantId = participantId;
            self.conversationModalConversationId = conversationId;
            MessengerConversationModalController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: MessengerConversationModalController,
                controllerAs: 'messengerConversationModalController',
                templateUrl: '/conversation/messenger/modal/main',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                onComplete: self.scrollToNewestMessage
            });
        };

        self.scrollToNewestMessage = function () {
            $(function () {
                $(".messageLogs").animate({scrollTop: $(".messageLogs")[0].scrollHeight},600);
            });
        }

        let MessengerConversationModalController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.message = '';
            dCtrl.sms_character_limit = 140;
            dCtrl.page = self.conversationModalPage;
            dCtrl.participantId = self.conversationModalParticipantId;
            dCtrl.conversationId = self.conversationModalConversationId;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };

            dCtrl.setSmsCharacterLimit = function (limit) {
                dCtrl.sms_character_limit = limit;
            };

            dCtrl.setWhitelist = function (whitelist) {
                dCtrl.whitelist = whitelist;
            };

            dCtrl.getParticipant = function (participantId) {
                getParticipant(participantId)
                    .then(onParticipant, onError);
            };

            let onParticipant = function (data) {
                dCtrl.participant = data;
            };

            dCtrl.updateReadStatusForce = function (conversationId) {
                if (conversationId != undefined) {
                    messengerConversationService.updateReadStatus(conversationId, 1)
                        .then(onUpdateReadStatus, onError);
                }
            };

            let onUpdateReadStatus = function (data) {
                // TODO: add optional callback
            };

            dCtrl.getParticipantMessages = function(page, participantId) {
                messengerMessageService.getParticipantMessages(page, participantId)
                    .then(onParticipantMessages, onError);
                // if (dCtrl.getParticipantMessagesLoop == undefined) {
                //     dCtrl.getParticipantMessagesLoop = $interval(function () {
                //         dCtrl.getParticipantMessages(1, participantId);
                //     }, 3000);
                // }
            };

            let onParticipantMessages = function (data) {
                dCtrl.participantMessagesCount = 0;
                if (dCtrl.participantMessagesCount > 0
                    && data.total > dCtrl.participantMessagesCount) {
                    let difference = data.total - dCtrl.participantMessagesCount;
                    for (let i = 0; i < difference; i++) {
                        dCtrl.participantMessages.push(data.data[i]);
                    }
                } else {
                    dCtrl.participantMessages = data.data;
                }

                dCtrl.participantMessages.forEach(function (message, index) {
                    let urls = message.message.match(/\bhttps?:\/\/\S+/gi);

                    if (urls) {
                        urls.forEach(function (url, index) {
                            let anchor = document.createElement('a');
                            anchor.href = url;
                            if (anchor.hostname && dCtrl.whitelist.indexOf(anchor.hostname) > -1) {
                                this.message = this.message.replace(
                                    url,
                                    '<img src="' + url + '" alt="emoji" />'
                                );
                                // console.log(this.message);
                                this.isBindable = true;
                            }
                        }, this[index]);
                    }
                }, dCtrl.participantMessages);
                dCtrl.participantMessagesCount = data.total;
                dCtrl.isDataLoaded = true;
            };

            dCtrl.getExperiences = function() {
                messengerConversationService.getExperiences()
                    .then(onExperiences, onError);
            };

            let onExperiences = function (data) {
                dCtrl.experiences = data;
            };

            dCtrl.sendMessage = function () {
                if (dCtrl.currentExperience != undefined) {
                    messengerMessageService.sendExperienceRequestEvent(
                        dCtrl.participant.Id,
                        dCtrl.currentExperience
                    ).then(onSend, onError);
                } else {
                    if (dCtrl.message != undefined && dCtrl.message != '') {
                        messengerMessageService.send(dCtrl.participant.Id, dCtrl.message)
                            .then(onSend, onError);
                    }
                }
            };

            let onSend = function (data) {
                dCtrl.message = '';
                dCtrl.currentExperience = '';
                dCtrl.getParticipantMessages(1, dCtrl.participant.Id);
                dCtrl.updateSmsCounts();
                self.scrollToNewestMessage();
            };

            let onError = function (reason) {
                // TODO: Display appropriate error message
            };

            dCtrl.updateSmsCounts = function() {
                dCtrl.message_length = dCtrl.message.length;
                dCtrl.message_count = Math.ceil(dCtrl.message_length / dCtrl.sms_character_limit);
            };

            let init = function () {
                dCtrl.isDataLoaded = false;
                dCtrl.getParticipant(participantId);
                dCtrl.updateReadStatusForce(conversationId);
                dCtrl.getParticipantMessages(page, participantId);
                dCtrl.getExperiences();
            }();
        };

        return {
            getConversationModal: getConversationModal
        }

    }
]);
